import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewFAQPageNew from "../../components/FAQ/ViewFAQPageNew";



const ViewFAQPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="FAQ" link2="/faq" title="View FAQ" />

        {/* AddUserLayer */}
        <ViewFAQPageNew />


      </MasterLayout>
    </>
  );
};

export default ViewFAQPage;
